import { CurrencyISO } from '@guiker/money'

import { CommonPurchaseCost } from '../purchase-cost'

export const UnitedStatesPurchaseCost = {
  ...CommonPurchaseCost(CurrencyISO.USD),
} as const
